module.exports = __webpack_public_path__ + "img/web-p2-t1.54642b55.svg";